import { render, staticRenderFns } from "./PiecesList.vue?vue&type=template&id=1266e0de&"
import script from "./PiecesList.vue?vue&type=script&lang=js&"
export * from "./PiecesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports